import React from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'components/common/ColorPicker';
import { CUSTOM_TITLE_FIELD_PROPTYPES } from './';
import FieldWrapper from './FieldWrapper';


const ColorField = props => (
  <FieldWrapper {...props}>
    <ColorPicker
      name={props.name}
      value={props.value}
      clearable={props.clearable}
      onChange={props.onChange}
    />
  </FieldWrapper>
);

ColorField.propTypes = {
  ...CUSTOM_TITLE_FIELD_PROPTYPES,
  clearable: PropTypes.bool,
};

export default ColorField;
